'use client';

import type { EffectCallback } from 'react';
import { useEffect } from 'react';

/**
 * A hook that runs an effect only once (at mount).
 */
export function useEffectOnce(effect: EffectCallback) {
    useEffect(effect, []);
}
